import { SimpleShowLayout, EmailField, TextField, DateField,
  BooleanField, ChipField, SingleFieldList, TextInput, SelectInput, SelectArrayInput,
  ReferenceArrayField, ShowProps, AutocompleteArrayInput, ReferenceArrayInput, SimpleForm, email, required, BooleanInput, useGetIdentity } from "react-admin";
import { phoneValidation, plusParseFormat, uuidValidationErrorMessage } from "../shared-components";
import { LockAlert, UnlockButton } from "./unlock-button";
import { EditDriverToolbar } from "./edit-driver-toolbar";
import DeliveryMethodsField from "./delivery-methods-field";
import FountainURLField from "./fountain-url-field";

const validateEmail = [required(), email('Must be a valid Email')];
const validatePhone = phoneValidation;
const requiredField = required();
const employmentStatusFields = [
  { id: '3PL', name: 'Third Party' },
  { id: 'W2', name: 'Employee' },
  { id: '1099', name: 'Contractor' }
]
const deliveryMethodsFields = [
  { id: 'car', name: 'Car' },
  { id: 'bike', name: 'Bike' },
  { id: 'foot', name: 'Foot' },
  { id: 'moped', name: 'Moped' }
]

interface DriverFieldsProps extends ShowProps {
  id?: string;
  [key: string]: any;
}

// For Read only page
export const DriverFields: React.FC<DriverFieldsProps> = (props) => (
  <SimpleShowLayout {...props}>
    <LockAlert {...props} />
    <EmailField source="email" label="Email"/>
    <TextField source="phone" label="Phone"/>
    <TextField source="rails_id" label="Rails ID"/>
    {!!Number(props.record?.id) && <TextField source="technical_phone" label="Technical phone"/>}
    <TextField source="first_name" label="First name"/>
    <TextField source="last_name" label="Last name"/>
    <BooleanField source="active" label="Active Driver"/>
    <TextField source="employment_status" label="Employment status"/>
    <TextField source="authentication_id" label="Auth ID"/>
    <FountainURLField source="cosmos_data.fountain_id" label="Fountain ID"></FountainURLField>
    <DeliveryMethodsField source="cosmos_data.delivery_method_preferences" label="Delivery methods"></DeliveryMethodsField>
    <BooleanField source="cosmos_data.alcohol_delivery_preference" label="Alcohol delivery preference"/>
    <BooleanField source="is_driver_allowed_deliver_alcohol" label="Is allowed to deliver alcohol"/>
    <BooleanField source="is_driver_allowed_deliver_other_restricted_products" label="Is allowed to deliver other restricted products"/>
    <ReferenceArrayField source="driver_delivery_zone_ids" label="Delivery zones" reference="delivery-zone/search">
      <SingleFieldList>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
    <DateField source="updated_at" label="Last updated at" showTime/>
  </SimpleShowLayout>        
);

const getIsGimId = (id: string) => {
  return id.startsWith('gim')
}

// For Edit page
export const DriverInputs: React.FC<any> = (props) => {
  const { identity } = useGetIdentity();
  const isCompliance = identity?.driverRoles.includes('compliance')
  // only gim ids are allowed to edit alcohol/rp toggles
  const isGimId = getIsGimId(props.record?.id)
  return (
    <SimpleForm warnWhenUnsavedChanges toolbar={<EditDriverToolbar />} {...props}>
      <LockAlert {...props} button={<UnlockButton {...props}/>}></LockAlert>
      <TextInput source="email" type="email" label="Email" validate={validateEmail} variant="outlined"/>
      <TextInput source="phone" type="text" label="Phone" validate={[requiredField, validatePhone]} variant="outlined" parse={plusParseFormat}/>
      {!!Number(props.record?.id) && <TextInput source="technical_phone"
        type="text" label="Technical phone"
        validate={[requiredField, validatePhone]}
        variant="outlined"
        parse={plusParseFormat}/>}
      <TextInput source="first_name" type="text" label="First name" validate={requiredField} variant="outlined"/>
      <TextInput source="last_name" type="text" label="Last name" validate={requiredField} variant="outlined"/>
      {(isCompliance) && <TextInput source="cosmos_data.fountain_id" type="text" label="Fountain Id" validate={uuidValidationErrorMessage} variant="outlined"/>}
      <SelectInput source="employment_status" label="Employment status" choices={employmentStatusFields} optionText="name" optionValue="id" variant="outlined" disabled={props.record?.driver_delivery_zone_ids.length > 0 ? true : false}/>
      <SelectArrayInput source="cosmos_data.delivery_method_preferences" label="Delivery methods" choices={deliveryMethodsFields} optionText="name" optionValue="id" variant="outlined" />
      <ReferenceArrayInput source="driver_delivery_zone_ids" label="Delivery zones" reference="delivery-zone/search">
        <AutocompleteArrayInput 
          source="driver_delivery_zone_ids"
          translateChoice={false}
          suggestionLimit={20}
          variant="outlined"
        />
      </ReferenceArrayInput>		
      {(isCompliance && isGimId) && <BooleanInput source="is_driver_allowed_deliver_alcohol" label="Is allowed to deliver alcohol" />}
      {(isCompliance && isGimId) && <BooleanInput source="is_driver_allowed_deliver_other_restricted_products" label="Is allowed to deliver other restricted products" />}
    </SimpleForm>)
}
